module.exports = __webpack_public_path__ + "img/male-condom.b80558a6.png";